import { NAME } from './constants';

export const OPT_IN = `${NAME}/OPT_IN`;
export const OPT_IN_SUCCESS = `${NAME}/OPT_IN_SUCCESS`;

export const optIn = () => ({
  type: OPT_IN,
});
